// src/services/firebase.js
import { initializeApp, getApps, getApp } from "firebase/app"; // Added getApp
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getFunctions } from "firebase/functions";

const firebaseConfig = {
  apiKey: "AIzaSyA-3Vvzv_Vq_QBTRalUVZClt4vDb6Fl-ZY",
  authDomain: "testnix-c6c0f.firebaseapp.com",
  projectId: "testnix-c6c0f",
  storageBucket: "testnix-c6c0f.firebasestorage.app",
  messagingSenderId: "729089272612",
  appId: "1:729089272612:web:8f697ef3eab25cb55c21b1",
};

// ✅ Correct check: use getApp() (no 's') for existing instance
const app = !getApps().length ? initializeApp(firebaseConfig) : getApp();

// ✅ Export everything once clearly
export const auth = getAuth(app);
export const db = getFirestore(app);
export const functions = getFunctions(app, "us-central1"); // 👈 Use your specific region if applicable
export { app };